import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import RegistrationLayout from '../create-account/components/registration-layout';
import RegistrationFormContainer from '../create-account/components/registration-form-container';

import Input from '../../components/input-with-label';
import Checkbox from "../../components/checkbox";
import LargeButton from '../../components/buttons/large-button';

class Login extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <RegistrationLayout right={<RegistrationFormContainer heading='Login' text="Don't have an account yet?" linkText='Register' linkHref='#'> 
                    <div className="login-form__container gap">
                        <Input label="Email Address" type="email" 
                            name="email" placeholder=""/>
                        <Input label="Password" type="password" 
                            name="password" placeholder=""/>
                        <div className='login-form__bottom'>
                            <Checkbox text='Remember me'/>
                            <a href='#'>I forgot my password!</a>
                        </div>
                        <LargeButton className="button--login">Login</LargeButton>
                    </div>
                </RegistrationFormContainer>} />
            </>
        );
    }
}

export default Login;

// const el = document.getElementById('login-component');

// if (el) {
//     ReactDOM.render(<Login/>, el);
// }